import styled from "styled-components";
import { ContainerSection } from "@/main/components/shared/styles";

interface IAreaForm {
	gridTemplateColumns?: string;
}

export const Container = styled(ContainerSection)`
	margin-top: 2rem;
`;

export const HeaderSection = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 1rem;
`;

export const HeaderText = styled.h4`
	color: #000;
	font-size: 1rem;
	font-weight: bold;
	margin: 0;
`;

export const AreaForm = styled.div<IAreaForm>`
	display: grid;
	grid-template-columns: ${(props) => props.gridTemplateColumns || "1fr 1fr 1fr"};
	gap: 1rem;

	@media (max-width: 426px) {
		grid-template-columns: 1fr;

		button {
			width: 100%;
			max-width: 100%;
			padding: 0.4rem 0 !important;
			margin: 0;
		}
	}
`;
